import * as React from "react"
import { connect } from "react-redux"
import { GlobalState } from "../../../store"

import { Action, ActionType } from "@tenforce/toolbox-button-push-react"

import { Symbols } from "@tenforce/toolbox-fontmap"
import { CSSTransition } from "react-transition-group"
import SwitchTransition from "react-transition-group/SwitchTransition"

import { getBookmarkButton } from "../selectors"
import { DispatchProps, mapDispatchToProps } from "../actions"

export interface OwnProps {
    addBookmarkLabel: string
    removeBookmarkLabel: string
    bookmarkButtonId: string
    showCaption?: boolean
    actionType?: ActionType
    extraClasses?: string
}

interface StateProps {
    bookmarkButton: Bookmarks.BookmarkButton | null
}

type Props = OwnProps & StateProps & DispatchProps

export class BookmarkButton extends React.Component<Props> {
    render(): JSX.Element {
        const {
            bookmarkButtonId,
            addBookmarkLabel,
            removeBookmarkLabel,
            bookmarkButton,
            actionType = ActionType.icon,
            extraClasses = "",
            showCaption = false,
            unbookmark,
            addBookmark,
        } = this.props
        if (
            !bookmarkButton ||
            (!bookmarkButton.resourceId && bookmarkButton.resourceId !== 0) ||
            !bookmarkButton.resourceType
        ) {
            return <></>
        }

        const { bookmarkId, isLoading } = bookmarkButton

        const symbol = !!bookmarkId
            ? Symbols.BookmarkFilled
            : Symbols.BookmarkEmpty

        const text = bookmarkId ? removeBookmarkLabel : addBookmarkLabel

        const content = showCaption ? `${symbol} ${text}` : symbol

        return (
            <SwitchTransition>
                <CSSTransition
                    key={!!bookmarkId ? "bookmarked" : "not_bookmarked"}
                    in={true}
                    timeout={150}
                    classNames="bookmark-fade"
                >
                    <Action
                        id={bookmarkButtonId}
                        extraClasses={extraClasses}
                        isLoading={isLoading}
                        data-ft-is-bookmarked={!!bookmarkId}
                        actionType={actionType}
                        title={text}
                        onClick={(): void => {
                            bookmarkId
                                ? unbookmark(bookmarkButton)
                                : addBookmark(bookmarkButton)
                        }}
                    >
                        {content}
                    </Action>
                </CSSTransition>
            </SwitchTransition>
        )
    }
}

const mapStateToProps = (state: GlobalState, props: OwnProps): StateProps => ({
    bookmarkButton: getBookmarkButton(state.bookmarks, props),
})

export default connect(mapStateToProps, mapDispatchToProps)(BookmarkButton)
